import type { IconData } from '@stacksjs/iconify-core'

export const alignLetterRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 4H10a1 1 0 0 1 0-2h11a1 1 0 0 1 0 2m0 4H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m0 4H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m0 6H11a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2m0 4H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default alignLetterRight
